<template>
  <div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-10">
            <h4>Assuntos</h4>
        </div>
        <div class="col-md-2">
              <button class="btn btn-success" @click="cadastro()" style="margin-right: 5px; 
                  border-color: rgb(0, 150, 136); color: rgb(0, 150, 136);margin-top: 21px;float: right;margin-right: 22px;">Cadastrar</button>
        </div>
      </div>
    </div>

    <!--<div class="col-md-12" v-if="result_detalhes" style="transition-duration: 2.2s,.2s;">
      <div class="card" >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12" >Nome: {{result_detalhes.nome}}</div>
            <div class="col-md-12" >email: {{result_detalhes.email}}</div>
            <div class="col-md-12" >Tipo: {{result_detalhes.tipo}}</div>
            <div class="col-md-12" v-if="result_detalhes.departamento" >Departamento: {{result_detalhes.departamento}}</div>
          </div>

        </div>  
      </div> 
    </div> -->
    <div class="col-md-12" >
      <vue-good-table 
        :columns="columns"
        :rows="assunto"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
              enabled: true,
              mode: 'records',
              mode: 'pages',
              perPage: 5,
              position: 'bottom',
              perPageDropdown: [5, 10, 15],
              dropdownAllowAll: false,
              nextLabel: 'Próximo',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Linhas por página',
              ofLabel: 'de',
              pageLabel: 'pagina', 
              allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">

              <div v-if="props.column.field == 'status'">
                  <switch-button v-model="props.row.status" color="#253DB9" :meuid="props.row.id" modulo="assunto" funcao="exibirStatus"></switch-button>
              </div>

              <span v-if="props.column.field == 'action'">
           
                <button class="btn btn-primary" @click="editar(props.row)" style="margin-right:5px;"><i class="fa fa-pencil-square-o"></i></button>
                <button class="btn btn-danger" @click="delete_option(props.row.id)"><i class="fa fa-times"></i></button>
              </span>
        
              <span v-else>
                <span v-if="props.column.field != 'status'">
                   {{props.formattedRow[props.column.field]}}
                </span>   
              </span>

          </template>
      </vue-good-table> 
    </div>  
    
  </div>
  
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import axios from 'axios';
import store from "src/store.js"
import 'src/controller/sistema/assuntoSecretariaController.js'
import SwitchButton from 'src/components/switch.vue'

export default {
  name: 'my-component',
  components: {
    VueGoodTable,
    SwitchButton
  },
  data(){
    return {
      columns: [
        {
          label: 'Assunto',
          field: 'assunto',
        },
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Ações',
          field: 'action',
          sortable: false,
        },
        {
          label: 'id',
          field: 'id',
          hidden: true,
        }
        
      ],
      assunto:[],
      result_detalhes:null
    };
  },
   methods: {
      editar(row){
        this.$router.push({name: 'assuntoeditar',params:{row: row} } );
      },
      delete_option(id){
        if (confirm("Deseja excluir?")){
          this.deletar(id);
        } 
      },
      async deletar(id){
         await this.$deletarAssunto(id);
         this.assunto = [];
         this.listarTudo();
      },
      async listarTudo(){
        try {
           let a = await this.$assuntosAvan();
           let assunt = a.data.reverse();
           let status = null;
           assunt.forEach(array => {
              if(array.status == 1){
                 status = true;
                 let as_array={
                    assunto: array.assunto, 
                    status: status,
                    id: array.id
                 };
                 this.assunto.push(as_array);
              }else{
                 status = false;
                 let as_array={
                    assunto: array.assunto, 
                    status: status,
                    id: array.id
                 };
                 this.assunto.push(as_array);
              }
           });   
        } catch (e) {
              
        }
      },
      cadastro(){
        this.$router.push({name: 'assuntocadastro'} );
      }
   }, 
  beforeMount() {
    try {
      this.listarTudo();
    }catch(e){
      
    }    
    
  }
};
</script>

